import { render, staticRenderFns } from "./payFeeOrderResult.vue?vue&type=template&id=2ad7ce54&scoped=true"
import script from "./payFeeOrderResult.vue?vue&type=script&lang=js"
export * from "./payFeeOrderResult.vue?vue&type=script&lang=js"
import style0 from "./payFeeOrderResult.vue?vue&type=style&index=0&id=2ad7ce54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7ce54",
  null
  
)

export default component.exports